import 'fotorama/fotorama.js';
import 'fotorama/fotorama.css';

import { offerTextExpander, offerOrderForm, convertOfferClickToLink } from '../contrib/market';

window.Elec.Market = {
  convertOfferClickToLink: convertOfferClickToLink,
  offerTextExpander: offerTextExpander,
  offerOrderForm: offerOrderForm,
};
